import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { Router } from '@angular/router';
import {MatSnackBar} from '@angular/material/snack-bar';
import { FormControl } from '@angular/forms';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { ServerUrlService } from 'src/app/services/server-url.service';
import { Console } from 'console';
import { VinculoUsuariosService } from 'src/app/incorporated/services/vinculo-usuarios.service';

interface Response extends Array<any> {}
declare const window: any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  @Input() stepper: any;
  @Input() tipo: number;
  @Input() userRegister: any;
  @Input() consultaHorarios: any;
  @Input() sessionData: any = {};
  @Output() userLgdIn = new EventEmitter<any>();
  @Output() alteraModoCadastro = new EventEmitter<any>();
  @Output() userLogOut = new EventEmitter<any>();
  email: string;
  senha: string;
  loginErro: string;
  emailInvalid: boolean;
  smallScreen: boolean;
  EmailControl =  new FormControl();
  SenhaControl = new FormControl();
  recuperarSenha: boolean;

  constructor(
    private auth: AuthService,
    private router: Router,
    private snackBar: MatSnackBar,
    private breakpointObserver: BreakpointObserver,
    private serverUrlService: ServerUrlService,
    private vinculoUsuario: VinculoUsuariosService
  ) {

    this.smallScreen = (window.innerWidth <= 400) ? true : false;
    breakpointObserver.observe([
      Breakpoints.XSmall,
      Breakpoints.Small
    ]).subscribe(result => {
      this.smallScreen = result.matches;
    });
    this.recuperarSenha = false;
   }

  ngOnInit() {
    this.emailInvalid = false;
  }

  onLoginPressed() {
    const { modo } = this.sessionData;

    this.auth.userLogin(this.email, this.senha, modo)
      .subscribe(
        (data: Response[any]) => {
          if (data) {
            if(data.userData.integracao_id) {
              this.vinculoUsuario.getPaciente(data.userData.integracao_id).subscribe((resp: any) => {
                const formattedUserData = {
                  ...data.userData,
                  ocultar_historico: resp && resp.ocultarhistorico ? resp.ocultarhistorico : false
                }
                sessionStorage.setItem('userData', JSON.stringify(formattedUserData))
              })
            }else {
              sessionStorage.setItem('userData', JSON.stringify({...data.userData, ocultar_historico: false}))
            }

            this.auth.setUser(data.userData)
            this.userLgdIn.emit(data);

            if (window.ReactNativeWebView) {
              window.ReactNativeWebView.postMessage(JSON.stringify(data.userData));
            }

            if (this.stepper) {
              setTimeout(() => {
                this.stepper.next();
              }, 10);
            } else if (modo === 'admin') {
              this.router.navigate(['/' + this.serverUrlService.getName() + '/admin/agendamentos']);
            } else {
              this.router.navigate(['/' + this.serverUrlService.getName() + '/client/agendamento']);
            }
          } else {
            // this.loginErro = 'Usuário e/ou senha incorreto(s).';
            this.snackBar.open('Email e/ou senha incorreto(s).', '', {duration: 3000});
            this.EmailControl.setErrors({ incorrect: true});
            this.SenhaControl.setErrors({ incorrect: true });
          }
        },
        (err) => {
          console.error('Err', err)
          this.snackBar.open('Email e/ou senha não informado.', '', {duration: 3000});
          this.EmailControl.setErrors({ incorrect: true});
          this.SenhaControl.setErrors({ incorrect: true });
          // this.loginErro = 'Favor inserir email e senha.'
        }
    )
  }

  onRegistrarConta() {
    if (this.userRegister) {
      this.alteraModoCadastro.emit();
    } else {
      this.router.navigate(['/' + this.serverUrlService.getName() + '/client/cadastro']);
    }
  }

  onVoltarClick() {
    this.stepper.previous();
  }

  onVoltarLogin() {
    this.recuperarSenha = false;
  }

  onEsqueciSenhaClick() {
    // this.router.navigate(['client/recuperasenha', this.email || '']);
    this.recuperarSenha = true;
  }

  LimparError() {
    this.EmailControl.setErrors(null);
    this.SenhaControl.setErrors(null);
  }
}
